import { render, staticRenderFns } from "./PrebilledAmount.vue?vue&type=template&id=4eb59a35&scoped=true"
import script from "./PrebilledAmount.vue?vue&type=script&lang=js"
export * from "./PrebilledAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb59a35",
  null
  
)

export default component.exports